import { gql } from '@apollo/client';

export const LEARNING_OBJECT_QUERY = gql`
    query learningObject($objectID: UUID!) {
        object(objectID: $objectID) {
            node {
                id
                tags
                format
                duration
                expireAt
                courseCount
                locales {
                    locale
                    name
                    description
                }
                assets {
                    edges{
                        isDefault
                        node {
                            id
                            name
                            url
                            mimetype
                            encoding
                            createdAt
                            updatedAt
                            locales
                            lxpFileId
                        }
                    }
                }
                metadata
                createdAt
                updatedAt
            }
        }
    }
`;
